import {connect} from 'react-redux';

import {AsyncHandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {createLensAsyncAction, LensTemplate} from '../../../../store/data/lenses/saveLensActions';
import {getUserNamespace} from '../../../../store/data/teammates/teammatesSelectors';
import {LensesWorkspacesCreateDialog} from './lensesWorkspaceCreateDialog';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  userNamespace: getUserNamespace,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  createLensAsync: createLensAsyncAction,
}));

export const LensesWorkspacesCreateDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const onSubmit: AsyncHandlerOf<LensTemplate> = async (template) => {
      await dispatchProps.createLensAsync(template);
    };
    return {
      ...ownProps,
      ...stateProps,
      onSubmit,
    };
  },
)(LensesWorkspacesCreateDialog);
